import React, { useEffect } from 'react';
import styled, { css } from 'styled-components';
import { CommonText } from '../bumpViews/commonText';
import { IoMdClose, IoMdArrowBack } from 'react-icons/io';

export const IconSettings = ({ onClick }: { onClick?: () => void; }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="19" viewBox="0 0 24 24" fill="none" onClick={onClick}>
      <mask id="mask0_475_4573" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_475_4573)">
        <path d="M13.8748 22H10.1248C9.87485 22 9.65818 21.9167 9.47485 21.75C9.29152 21.5833 9.18318 21.375 9.14985 21.125L8.84985 18.8C8.63318 18.7167 8.42902 18.6167 8.23735 18.5C8.04568 18.3833 7.85818 18.2583 7.67485 18.125L5.49985 19.025C5.26652 19.1083 5.03318 19.1167 4.79985 19.05C4.56652 18.9833 4.38318 18.8417 4.24985 18.625L2.39985 15.4C2.26652 15.1833 2.22485 14.95 2.27485 14.7C2.32485 14.45 2.44985 14.25 2.64985 14.1L4.52485 12.675C4.50818 12.5583 4.49985 12.4458 4.49985 12.3375V11.6625C4.49985 11.5542 4.50818 11.4417 4.52485 11.325L2.64985 9.9C2.44985 9.75 2.32485 9.55 2.27485 9.3C2.22485 9.05 2.26652 8.81667 2.39985 8.6L4.24985 5.375C4.36652 5.14167 4.54568 4.99583 4.78735 4.9375C5.02902 4.87917 5.26652 4.89167 5.49985 4.975L7.67485 5.875C7.85818 5.74167 8.04985 5.61667 8.24985 5.5C8.44985 5.38333 8.64985 5.28333 8.84985 5.2L9.14985 2.875C9.18318 2.625 9.29152 2.41667 9.47485 2.25C9.65818 2.08333 9.87485 2 10.1248 2H13.8748C14.1248 2 14.3415 2.08333 14.5248 2.25C14.7082 2.41667 14.8165 2.625 14.8498 2.875L15.1498 5.2C15.3665 5.28333 15.5707 5.38333 15.7623 5.5C15.954 5.61667 16.1415 5.74167 16.3248 5.875L18.4998 4.975C18.7332 4.89167 18.9665 4.88333 19.1999 4.95C19.4332 5.01667 19.6165 5.15833 19.7498 5.375L21.5998 8.6C21.7332 8.81667 21.7748 9.05 21.7248 9.3C21.6749 9.55 21.5499 9.75 21.3498 9.9L19.4748 11.325C19.4915 11.4417 19.4998 11.5542 19.4998 11.6625V12.3375C19.4998 12.4458 19.4832 12.5583 19.4499 12.675L21.3249 14.1C21.5249 14.25 21.6499 14.45 21.6999 14.7C21.7498 14.95 21.7082 15.1833 21.5749 15.4L19.7248 18.6C19.5915 18.8167 19.404 18.9625 19.1623 19.0375C18.9207 19.1125 18.6832 19.1083 18.4499 19.025L16.3248 18.125C16.1415 18.2583 15.9498 18.3833 15.7498 18.5C15.5498 18.6167 15.3498 18.7167 15.1498 18.8L14.8498 21.125C14.8165 21.375 14.7082 21.5833 14.5248 21.75C14.3415 21.9167 14.1248 22 13.8748 22ZM12.0498 15.5C13.0165 15.5 13.8415 15.1583 14.5248 14.475C15.2082 13.7917 15.5498 12.9667 15.5498 12C15.5498 11.0333 15.2082 10.2083 14.5248 9.525C13.8415 8.84167 13.0165 8.5 12.0498 8.5C11.0665 8.5 10.2373 8.84167 9.56235 9.525C8.88735 10.2083 8.54985 11.0333 8.54985 12C8.54985 12.9667 8.88735 13.7917 9.56235 14.475C10.2373 15.1583 11.0665 15.5 12.0498 15.5Z" fill="#4B4F5E" />
      </g>
    </svg>
  )
}

const SidebarOverlay = styled.div<{ isSidebarOpen: boolean, isDetailOrder?: boolean }>`
  position: fixed;
  display: ${({ isSidebarOpen }) => (isSidebarOpen ? 'block' : 'none')};
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: ${({ isDetailOrder }) => (isDetailOrder ? 'rgba(0, 0, 0, 0.05)' : 'rgba(0, 0, 0, 0.5)')};
  z-index: 101;
`;

const SidebarWrapper = styled.div<{ isOpen: boolean; isMobile?: boolean; width?: number }>`
  position: fixed;
  height: 100vh;
  background: #fff;
  z-index: 101;
  transition: 0.25s;
  width: 0;
  display: none;

  @media (max-width: 767px) {
      transform: translateY(100%);
  }
  ${({ isOpen, isMobile, width }) => {
    if (isOpen) {
        return css`
          width: ${width}px;
          right: 0;
          top: 0;
          display: block;
          @media (max-width: 767px) {
            width: 100%;
            top: 0;
            transform: translateY(0%);
            left: 0;
          }
        `
    }
  }}
`;

const SideBarHeader = styled.div<{ version: string }>`
  padding: ${({ version }) => (version === 'v2' ? '16px' : '16px')};
  display: flex;
  justify-content: ${({ version }) => (version === 'v2' ? 'center' : 'space-between')};
  border-bottom: ${({ version }) => (version === 'v2' ? '1px solid #DFDFDF' : '')};
  align-items: center;
  svg {
    cursor: pointer;
  }

`;

const SidebarBody = styled.div<{ isMobile?: boolean; }>`
  height: ${({ isMobile }) => (isMobile ? 'calc(100% - 56px)' : '')};
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  @media (max-width: 1370px) {
    height:  ${({ isMobile }) => (isMobile ? 'calc(100% - 100px)' : '')};
  };
  overflow-y: scroll;
  ::-webkit-scrollbar {
    width: 5px;
    height: 10px;
  }
  ::-webkit-scrollbar-thumb {
    background-color: #D9D9D9;
  }
  ::-webkit-scrollbar-track {
    background-color: transparent;
  }
`;

const SidebarBodyTop = styled.div`
  margin-bottom: 20px;
`;

const FooterWrapper = styled.div<{ width: number; version?: string }>`
  position: fixed;
  display: flex;
  padding: 12px 24px 24px 24px;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  border-top: 1px solid #dfdfdf;
  background: #fefefe;
  width: ${({ width }) => width}px;
  bottom: 0;
  @media (max-width: 767px) {
        width: 100vw;
  }
  ${({ version }) => (version === 'v2' ?
    css`
    padding: 16px;
  `
    : '')}
    
`;
const MenuId = styled.span`
  font-size: large;
  font-weight: 400;
  color: #4B4F5E;
`;

const HeaderWrapper = styled.span<{isNoMargin?: boolean}>`
  display: flex;
  gap: 5px;
   @media (max-width: 767px) {
      margin-left: ${({ isNoMargin }) => isNoMargin ? 0 : '33px'}
  }
`;

const BackIconWrapper = styled.span`
  position: absolute;
  left: 5%;
`;

const MenuName = styled.span`
  font-size: large;
  font-weight: 600;
  color: #4B4F5E;
  word-break: break-all;
`;
type SidebarProps = {
  isOpen: boolean;
  isMobile?: boolean;
  children: React.ReactNode;
  headerTitle: string;
  menuName?: {
    name: string;
    _id: string;
  } | null;
  haveItemId?: boolean;
  onClose: () => void;
  width?: number;
  version?: string;
  optional?: string;
  isLandingPageMobile?: boolean;
  isDetailOrder?: boolean;
  isNoMargin?: boolean;
  isQuickSettings?: boolean;
  border?: boolean;
};

export const Sidebar: React.FC<SidebarProps> = ({ isOpen, headerTitle, onClose, children, width = 400, menuName, haveItemId = true, version = 'v1', isMobile = false, optional, isLandingPageMobile = false, isDetailOrder=false, isNoMargin= false, isQuickSettings=false }) => {
  useEffect(() => {
    const scrollRootElement = document.getElementById('scroll-root');
    if (scrollRootElement && isOpen) {
      scrollRootElement.style.overflowY = 'hidden';
    }
    if (scrollRootElement && !isOpen) {
      scrollRootElement.style.overflowY = 'auto';
    }
    if (scrollRootElement && isMobile) {
      scrollRootElement.style.overflowY = 'unset';
    }

  }, [isOpen]);
  return (
    <>
      <SidebarOverlay isSidebarOpen={isOpen} isDetailOrder={isDetailOrder}/>
      <SidebarWrapper isOpen={isOpen} width={width} isMobile={isMobile}>
        <SideBarHeader version={version}>
          {(version === 'v2' || !!isLandingPageMobile) && <BackIconWrapper>
            <IoMdArrowBack size={24} onClick={onClose} />
          </BackIconWrapper>}
          <HeaderWrapper isNoMargin={isNoMargin}>
            {isQuickSettings && <div style={{ display: 'flex', padding: '1px 8px 0 0'}}><IconSettings /></div>}
            <CommonText size="large" weight={600} color="#0C202A">
              {headerTitle}
              {menuName && (
                <>
                  {' '} - <MenuName>{menuName.name}</MenuName> {haveItemId && <MenuId>({menuName._id})</MenuId>}
                </>
              )}
            </CommonText>
            <CommonText size="semiMedium" weight={400} color="#4B4F5E">
              {optional}
            </CommonText>
          </HeaderWrapper>
          {version === 'v1' && <IoMdClose size={24} onClick={onClose} />}
        </SideBarHeader >
        {children}
      </SidebarWrapper >
    </>
  );
};

export const SidebarBodySection = SidebarBody;
export const SidebarBodySectionTop = SidebarBodyTop;

type FooterSectionProps = {
  width?: number;
  version?: string;
  style?: any;
  children: React.ReactNode;
}

export const FooterSection: React.FC<FooterSectionProps> = ({ width = 380, style, children, version = 'v1' }) => (
  <FooterWrapper width={width} version={version} style={{ ...style }}>
    {children}
  </FooterWrapper>
);
